/** Avatar URL from users/me or photo PATCH payloads (field names vary by API version). */
export function pickProfileAvatarUrl(user) {
  if (!user || typeof user !== "object") return ""
  const raw =
    user.avatar ??
    user.photoUrl ??
    user.profilePictureUrl ??
    user.profileImage ??
    user.profile_image ??
    user.photo ??
    ""
  return String(raw).trim()
}

/** Server avatar with optional cache-bust after upload; prefer local blob while uploading. */
export function profileAvatarDisplayUrl(user, { localObjectUrl = null } = {}) {
  if (localObjectUrl) return localObjectUrl
  const base = pickProfileAvatarUrl(user)
  if (!base) return ""
  const bust = user?.avatarCacheBust
  if (!bust || base.startsWith("blob:") || base.startsWith("data:")) return base
  const sep = base.includes("?") ? "&" : "?"
  return `${base}${sep}v=${bust}`
}
